
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Difficulty, ModifiedRecipe } from '~/types';
import ParameterCircle from '../../UserProfile/shared/ParameterCircle.vue';
import RecipeShare from './RecipeShare.vue';
import PianoCustomerStateHandler from '../../../../libraries/piano/src/components/PianoCustomerStateHandler.vue';

interface Props {
  recipe: ModifiedRecipe;
  mode: string;
}

interface Computed {
  token: boolean;
  isFavourite: boolean;
  favouriteRecipesIds: string[];
  ingredientsTotal: number;
  difficulty: Difficulty;
  iconDifficulty: string;
}

interface Methods {
  openFavouriteModal: () => void;
  print: () => void;
  description: (description: string) => string;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  components: {
    PianoCustomerStateHandler,
    ParameterCircle,
    RecipeShare,
  },
  props: {
    recipe: { type: Object },
    mode: { type: String },
  },
  methods: {
    openFavouriteModal() {
      this.$store.commit('toggleModal', { modal: 'center', centerType: 'favourite', id: this.recipe.id });
    },
    print() {
      this.$store.commit('analytics/setClickEvent', {
        cXense: {
          eventName: 'share_recipe',
          eventData: {
            share_channel: 'Print',
            recipe_name: this.recipe.title.toLowerCase(),
            recipe_id: this.recipe.id,
            recipe_author: this.recipe.author.toLowerCase(),
          },
        },
      });
      window?.print();
    },
    description(preparationTimeUnit) {
      switch (preparationTimeUnit) {
        case 'h':
          // @ts-ignore
          return this.title > 1 ? 'tundi' : 'tund';
        case 'min':
          // @ts-ignore
          return this.title > 1 ? 'minutit' : 'minut';
        default:
          // @ts-ignore
          return this.desc;
      }
    },
  },
  computed: {
    ...mapGetters(['favouriteRecipesIds', 'token']),
    isFavourite() {
      return this.favouriteRecipesIds.includes(this.recipe.id);
    },
    ingredientsTotal() {
      return this.recipe.blocks.reduce((acc, block) => acc + block.ingredients.length, 0);
    },
    difficulty() {
      return Difficulty[this.recipe.difficulty as keyof typeof Difficulty];
    },
    iconDifficulty() {
      switch (this.difficulty) {
        case 'Lihtne':
          return 'chart-lihtne';
        case 'Keeruline':
          return 'chart-keeruline';
        default:
          return 'chart-keskmine';
      }
    },
  },
});
